import React from 'react';
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import DropContainer from "./DropContainer";
import {withRouter} from "react-router-dom";

class Seats extends React.Component {

  render() {
    return(
      <DndProvider backend={HTML5Backend}>
        <div className="md-seat-app">
          <DropContainer/>
        </div>
      </DndProvider>
    )
  }

}

export default withRouter(Seats);
